import { createFileRoute } from '@tanstack/react-router';

import { WorkersPage } from '@/features/talent/workers-page';

export const Route = createFileRoute('/_app/marketplace/workers/')({ component: WorkersPage });
